import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Location } from '@angular/common';

export interface HeaderAction {
  label: string;
  icon?: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'success' | 'error';
}

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css',
})
export class PageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() icon: string = '';
  @Input() showBackButton: boolean = false;
  @Input() variant: 'gradient' | 'light' = 'gradient';
  @Input() actions: HeaderAction[] = [];

  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }

  handleAction(action: HeaderAction): void {
    action.onClick();
  }
}
